{
  "instances": {
    "httptrace": {
      "label": "HTTP Traces",
      "chart": {
        "avg_time": "ø duração",
        "max_time": "duração máxima",
        "status_4xx": "status 4xx",
        "status_5xx": "status 5xx",
        "successful_requests": "Requisições sucedidas",
        "total_requests": "total de requisições"
      },
      "content_type_response": "Response Content-Type",
      "content_type_request": "Request Content-Type",
      "length_request": "Request Length",
      "fetching_failed": "Falha na busca de traces.",
      "limit": "limite",
      "filter": {
        "client_errors": "erros de cliente",
        "exclude_actuator": "excluir {actuator}/**",
        "server_errors": "erros do servidor",
        "success": "sucesso"
      },
      "length_response": "Response Tamanho",
      "method": "Metodo",
      "no_traces_found": "Nenhum trace encontrado.",
      "status": "Status",
      "time": "Tempo",
      "timestamp": "Timestamp",
      "uri": "Caminho"
    }
  }
}
